import React from "react";
import { Outlet } from "@bcm-dev/bcms-vite";
import MainContentContainer, { MainContentHeader } from "components/shared/containers/MainContentContainer";

/**
 * @function ManagePaymentAccountsPage
 * @return {React.Component}
 * @exported true
 * @description The main component for ManagePaymentAccountsPage
 */
export default function ManagePaymentAccountsPage(props) {
    return (
        <MainContentContainer className="manage-payment-accounts-page" header={<MainContentHeader text="Manage Payment Accounts" />}>
            <Outlet />
        </MainContentContainer>
    )
}

